import React from 'react';
import { Grid, Typography } from '@mui/material';
import ForgetPasswordForm from './ForgetPasswordForm';
import { Link, useSearchParams } from 'react-router-dom';
import { useResize } from 'hooks/common';
import { SPARK_ROUTES } from 'constants/routes';
import MainAuthScreenWrapper from '../MainAuthScreenWrapper';
import { SparkImageLoader } from 'sharedComponents/UI';

type ForgetPasswordProps = {
  showLogo?: boolean;
  modalView?: boolean;
  onSigIinClick?: () => void;
};

function ForgetPassword({
  showLogo = true,
  modalView,
  onSigIinClick,
}: ForgetPasswordProps) {
  const { isMobile } = useResize();
  const [searchParams] = useSearchParams();
  const scoID = searchParams.get('sco_id');

  const handleSignInNavigation = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    if (modalView && onSigIinClick) {
      e.preventDefault();
      onSigIinClick();
      return;
    }
  };

  return (
    <MainAuthScreenWrapper
      modalView={modalView}
      gridContainerStyle={{ width: '80%', maxWidth: '600px !important' }}
    >
      <Grid
        item
        container
        flex={1}
        justifyContent='center'
        alignItems='center'
        height='100%'
      >
        <Grid
          container
          justifyContent='center'
          direction='column'
          paddingX={2}
          rowGap={4}
        >
          {showLogo && (
            <Grid
              container
              rowGap={4}
              justifyContent='center'
              alignItems='center'
            >
              <a href='https://sparkup.ai/'>
                <SparkImageLoader
                  src='/SparkLogo.svg'
                  alt='spark-logo'
                  height={isMobile ? 46 : modalView ? 50 : 58}
                  width={435.18}
                />
              </a>
            </Grid>
          )}
          <Grid container direction='column' gap={2}>
            <Typography
              sx={{
                fontSize: '26px',
                fontFamily: 'Mont-semibold',
              }}
            >
              Forgot Password
            </Typography>
            <Typography
              sx={{
                fontSize: '18px',
              }}
            >
              A link to reset your password will be sent to your email
            </Typography>
          </Grid>
          <ForgetPasswordForm />

          <Grid item container justifyContent='center'>
            <Link
              onClick={handleSignInNavigation}
              to={{
                pathname: SPARK_ROUTES.LOGIN,
                search: !!scoID ? `sco_id=${scoID}` : '',
              }}
              style={{ textDecoration: 'none' }}
            >
              <Typography
                style={{
                  textDecoration: 'none',
                  fontSize: '14px',
                  color: '#6267AC',
                }}
              >
                Login
              </Typography>
            </Link>
          </Grid>
        </Grid>
      </Grid>
    </MainAuthScreenWrapper>
  );
}

export default ForgetPassword;
